<div class="wms-search-container" [ngStyle]="{'width': width}">
    <i class="wm-icon wms wms-search"></i>
    <input #searchinputEl [attr.name]="name" [(ngModel)]=searchKey (ngModelChange)="changed()" #searchinput="ngModel" type="text" placeholder="{{placeholder}}" title="Enter search term" class="wms-search-input" maxlength="100" autocomplete="off" [disabled]=disabled>
    <i class="wm-icon wms wms-clear" [hideIcon]="hideSearchIcon" (click)="clearSearch()"></i>
</div>
